jQuery(document).ready(function ($) {
    let lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy-load-image'
    });

// modernizr - for browsers, which not support object-fit --start
    if (!Modernizr.objectfit) {
        $('.images--object-fit').each(function () {
            const $container = $(this),
                imgUrl = $container.find('img').attr('data-src');

            if (imgUrl) {
                $container
                    .css('backgroundImage', 'url(' + imgUrl + ')')
                    .addClass('compat-object-fit');
            }
        });
    }
    // modernizr - for browsers, which not support object-fit --end

    //info-box popup
    let $infoBoxElement = $('.info-box');

    if ($infoBoxElement.length) {
        let $closeButton = $infoBoxElement.find('.info-box-popup .close-btn');
        let $openButton = $infoBoxElement.find('.info-box__link');
        let $popup = $infoBoxElement.find('.info-box-popup');

        $openButton.on('click', function(event) {
            event.preventDefault();
            $popup.fadeIn();
            // Additional code for handling mobile view
        });

        $closeButton.on('click', function() {
            $popup.fadeOut();
            // Additional code for handling mobile view
        });

        // Click outside to close
        $(window).on('click', function(event) {
            if (!$(event.target).closest('.info-box__link').length &&
                !$(event.target).closest('.info-box-popup__content').length) {
                $popup.fadeOut();
                // Additional code for handling mobile view
            }
        });

        // Handle the browser back button
        $(window).on("popstate", function() {
            $popup.fadeOut();
        });
    }


    //coupon
    $(".coupon").click(function (e) {
        let $coupon = $(e.currentTarget).data('coupon-code');
        let $input = $('<input>');

        $('body').append($input);
        $(e.currentTarget).addClass('active');
        $input.val($coupon).select();
        document.execCommand("copy");
        $input.remove();
        setTimeout(function(){               //show tooltip 3s after click on coupon
            $(".coupon").removeClass("active");
        }, 1500);
    });


    //js-cookie, covid notice
    $(".notice-close-btn").on("click", function (e) {
        e.preventDefault();
        Cookies.set('covid_notice_accepted', '1', { expires: 30 });
        $(e.currentTarget).closest(".notice").hide();
    });
});

//Add animation for podium
document.addEventListener('DOMContentLoaded', function() {
    const viewportWidth = window.innerWidth;

    if (viewportWidth > 801) {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animatePodiumCards();
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        const podium = document.querySelector('.podium');
        if (podium) {
            observer.observe(podium);
        }
    }
});

function animatePodiumCards() {
    const centerCard = document.querySelector('.podium__card:nth-child(1)');
    const leftCard = document.querySelector('.podium__card:nth-child(2)');
    const rightCard = document.querySelector('.podium__card:nth-child(3)');

    const centerCardAnimationDuration = 1;

    const startSideCardsAt = centerCardAnimationDuration / 2;

    if (centerCard) {
        centerCard.classList.add('fadeInUpCenterCard');
        centerCard.addEventListener('animationend', () => {
            const trophyIcon = centerCard.querySelector('.podium__trophy-icon');
            if (trophyIcon) {
                trophyIcon.classList.add('fadeIn');
            }

            startSideCardsAnimation();
            setTimeout(() => {
                trophyIcon.style.opacity = '1';
            }, 750);
        });
    }

    setTimeout(() => {
        leftCard.classList.add('slideInFromBottomLeft');
        rightCard.classList.add('slideInFromBottomRight');
    }, startSideCardsAt * 1000);

    function startSideCardsAnimation() {

        setTimeout(() => {
            leftCard.classList.add('slideInFromBottomLeft');
            rightCard.classList.add('slideInFromBottomRight');
        }, 100);


        centerCard.removeEventListener('animationend', startSideCardsAnimation);
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const partnerNames = document.querySelectorAll('.partner-name');
    const cardsContainers = document.querySelectorAll('.testimonials-partners__cards');
    let activeContainer = null;
    const nextButton = document.querySelector('.btn--next');
    const prevButton = document.querySelector('.btn--prev');

    if (nextButton) {
        nextButton.addEventListener('click', () => cycleCards('next'));
    }
    if (prevButton) {
        prevButton.addEventListener('click', () => cycleCards('prev'));
    }

    function updateCardsList(container) {
        return Array.from(container.querySelectorAll('.testimonials-partners__card:not(.empty-card):not(.virtual-testimonial-card)'));
    }
    function cycleCards(direction) {
        const activeContainer = document.querySelector('.testimonials-partners__cards.active');
        let realCards = updateCardsList(activeContainer);

        if (realCards.length === 0) {
            return;
        }

        if (direction === 'next') {
            const firstRealCard = realCards[0];
            const lastRealCard = realCards[realCards.length - 1];
            activeContainer.insertBefore(firstRealCard, lastRealCard.nextSibling);
        } else {
            const lastRealCard = realCards.pop();
            activeContainer.insertBefore(lastRealCard, realCards[0] || activeContainer.firstChild);
        }

    }

    function initializeCards() {
        if (!activeContainer) return;
        const cards = Array.from(activeContainer.querySelectorAll('.testimonials-partners__card:not(.virtual-testimonial-card):not(.empty-card)'));
        cards.forEach((card, index) => {
            card.setAttribute('data-index', index);
        });
        applyCardStyles();
    }


    function applyCardStyles() {
        const cards = Array.from(activeContainer.querySelectorAll('.testimonials-partners__card'));
        cards.sort((a, b) => parseInt(a.getAttribute('data-index')) - parseInt(b.getAttribute('data-index')));
        cards.forEach((card, index) => {
            const zIndex = cards.length - index;
        });
    }

    function resetDisplay() {
        partnerNames.forEach(partner => partner.classList.remove('active'));
        cardsContainers.forEach(container => {
            container.classList.remove('active');
            container.style.display = 'none';
        });
    }

    function showPartnerCards(partnerId) {
        resetDisplay();
        activeContainer = document.querySelector(`.testimonials-partners__cards[data-partner-id="${partnerId}"]`);
        if (activeContainer) {
            activeContainer.classList.add('active');
            activeContainer.style.display = 'block';
            initializeCards();
        }
        partnerNames.forEach(partner => {
            partner.classList.remove('active');
            if (partner.getAttribute('data-partner-id') === partnerId) {
                partner.classList.add('active');
            }
        });
    }


    partnerNames.forEach(partner => {
        partner.addEventListener('click', function() {
            showPartnerCards(this.getAttribute('data-partner-id'));
        });
    });

    if (partnerNames.length > 0) {
        const firstPartnerId = partnerNames[0].getAttribute('data-partner-id');
        partnerNames[0].classList.add('active');
        showPartnerCards(firstPartnerId);
    }

});


//Add animation for tabs
window.addEventListener('load', function() {
    const partnerList = document.querySelector('.partner_list');
    const partnerNames = document.querySelectorAll('.partner-name');
    const indicator = document.createElement('div');
    indicator.className = 'indicator';
    
    if(partnerList){
        partnerList.appendChild(indicator);
    }

    function setActiveTab() {
        partnerNames.forEach(partner => partner.classList.remove('active'));
        this.classList.add('active');
        updateIndicator(this);
    }

    function updateIndicator(activeTab) {
        const rect = activeTab.getBoundingClientRect();
        const listRect = partnerList.getBoundingClientRect();
        const left = rect.left - listRect.left + partnerList.scrollLeft;
        const width = rect.width;

        indicator.style.left = `${left}px`;
        indicator.style.width = `${width}px`;
    }

    function handleResize() {
        const activeTab = document.querySelector('.partner-name.active');
        if (activeTab) {
            updateIndicator(activeTab);
        }
    }

    partnerNames.forEach(partner => {
        partner.addEventListener('click', setActiveTab);
    });

    const initialActiveTab = document.querySelector('.partner-name.active') || partnerNames[0];
    if (initialActiveTab) {
        setActiveTab.call(initialActiveTab);
    }

    window.addEventListener('resize', handleResize);
});


//Add animation for pagination Testimonial
const testimonialBtn  = document.querySelectorAll('.testimonial-btn ');
const paginationWrapper = document.querySelector('.pagination-wrapper');
const bigDotContainer = document.querySelector('.big-dot-container');
const littleDot = document.querySelector('.little-dot');

for(let i = 0; i < testimonialBtn .length; i++) {
    testimonialBtn[i].addEventListener('click', btnClick);
}

function btnClick() {
    if(this.classList.contains('btn--prev')) {
        paginationWrapper.classList.add('transition-prev');
    } else {
        paginationWrapper.classList.add('transition-next');
    }

    const timeout = setTimeout(cleanClasses, 500);
}

function cleanClasses() {
    if(paginationWrapper.classList.contains('transition-next')) {
        paginationWrapper.classList.remove('transition-next')
    } else if(paginationWrapper.classList.contains('transition-prev')) {
        paginationWrapper.classList.remove('transition-prev')
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fadeInUp');
                observer.unobserve(entry.target);
            }
        });
    }, options);

    const elements = document.querySelectorAll('.podium__title, .podium__subtitle, .testimonials__title, .partner_list');
    elements.forEach(el => {
        observer.observe(el);
    });
});

document.addEventListener('DOMContentLoaded', function() {
    let animationPlayed = false;

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !animationPlayed) {
                const activeCards = entry.target.querySelectorAll('.testimonials-partners__cards.active');
                activeCards.forEach(card => {
                    card.classList.add('fadeInUpCards');
                });

                const hiddenCards = entry.target.querySelectorAll('.testimonials-partners__cards:not(.active)');
                hiddenCards.forEach(card => {
                    card.classList.add('fadeInUpCards');
                });

                observer.unobserve(entry.target);
                animationPlayed = true;

                setTimeout(() => {
                    activeCards.forEach(card => {
                        card.classList.remove('fadeInUpCards');
                    });
                    hiddenCards.forEach(card => {
                        card.classList.remove('fadeInUpCards');
                    });
                }, 1000);
            }
        });
    }, options);

    const reviewsList = document.querySelector('.reviews_list');
    if(reviewsList){
        observer.observe(reviewsList);
    }
});
